import { FormBuilder } from "components/FormBuilder/FormBuilder"
import React from 'react'
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { OnlineMerchantManagement } from "../OnlineMerchantManagement";
import { formPreventEnterSubmit } from "utils/utils";

/**
 * @param {object} props 
 * @param {import("react-hook-form").UseFormReturn} props.formProps
 * @param {{status: string, lockAccountType: string, remark: string}} props.currentStatus
 * @param {import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderSelectionOptionsType[]} props.suspendedOptions
 * @param {import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderSelectionOptionsType[]} props.terminatedOptions
 * @param {boolean} props.disabled
 * @returns 
 */
const OnlineMerchantManagementAccountStatusDialog = ({
  formProps,
  currentStatus,
  suspendedOptions,
  terminatedOptions,
  disabled
}) => {
  const { t: tLocal } = useTranslation("translation", { keyPrefix: "form.onlineMerchantManagement.components.accountStatusDialog" });
  const { t: tCommon } = useTranslation();

  const isDisabled = disabled;

  const selectedStatus = useWatch({
    control: formProps.control,
    name: "status",
    defaultValue: currentStatus.status
  });

  const showReason = ["SUSPENDED", "TERMINATED"].includes(selectedStatus);
  const showRemarks = useWatch({
    control: formProps.control,
    name: "lockAccountType",
    defaultValue: currentStatus.lockAccountType,
  }) === "OTHERS" && showReason;

  const lockOptions = selectedStatus === "SUSPENDED" ? suspendedOptions : terminatedOptions;

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    status: {
      fieldType: "selection",
      fieldName: "status",
      label: tLocal("label.status"),
      mandatory: true,
      disabled: isDisabled,
      config: {
        options: OnlineMerchantManagement.Options.accountStatus,
        defaultValue: currentStatus.status,
        customOnChangeFn: (newValue) => {
          newValue === "ACTIVE" && formProps.setValue("lockAccountType", "");
          newValue === "ACTIVE" && formProps.setValue("remark", "");
        }
      }
    },
    lockAccountType: {
      fieldType: "selection",
      fieldName: "lockAccountType",
      label: tLocal("label.lockAccountType"),
      mandatory: true,
      disabled: isDisabled,
      config: {
        options: lockOptions,
        defaultValue: currentStatus.lockAccountType,
        customOnChangeFn: () => {
          formProps.setValue("remark", "");
        }
      }
    },
    remark: {
      fieldType: "textInput",
      fieldName: "remark",
      label: tLocal("label.remark"),
      disabled: isDisabled,
      config: {
        multiline: true,
        defaultValue: currentStatus.remark
      }
    },
  }

  return (
    <form noValidate onKeyDown={formPreventEnterSubmit}>
      <FormBuilder.Row itemsPerRow={1}>
        {
          FormBuilder.buildFields({
            formProps,
            t: tCommon,
            fields: [
              fieldsConfig.status,
              showReason && fieldsConfig.lockAccountType,
              showRemarks && fieldsConfig.remark,
            ]
          })
        }
      </FormBuilder.Row>
    </form>
  )
}

export default OnlineMerchantManagementAccountStatusDialog